import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgOtpInputComponent } from './ng-otp-input/ng-otp-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { KeysPipe } from './pipes/keys.pipe';
import { NumberOnlyDirective } from './directives/number-only.directive';
const routes: Routes = [
  { path: 'otp', component: NgOtpInputComponent } // Add this route
];
@NgModule({
  declarations: [NgOtpInputComponent, KeysPipe, NumberOnlyDirective],
  imports: [
    CommonModule,
    FormsModule,

    ReactiveFormsModule,
    RouterModule.forChild(routes),
  ],
  exports :[
    NgOtpInputComponent
  ],
  providers: [KeysPipe]
})
export class NgOtpInputModule { 


  
}
